<template>
    <div class="modal fade" id="cartModal" ref="cartModal" tabindex="-1" aria-labelledby="cartModal" aria-hidden="true">
        <div
            class="modal-dialog modal-dialog-centered tablet:!w-[500px] !mx-2.5 tablet:!mx-[unset] !static tablet:!absolute !right-4 !top-0 !m-0 h-full">
            <div class="modal-content">
                <div class="modal-body !p-2.5 !pb-3">
                    <div
                        class="relative rounded-[10px] p-[12px] flex items-center mobile:h-[65px] largeDesktop:h-[80px] bg-customBlue-100">
                        <button type="button"
                            class="absolute top-3 right-[10px] w-6 h-6 z-50 focus:!outline-none focus:!shadow-none"
                            @click="closeModal">
                            <!-- <img src="../../../assets/images/modal-cross-icon.svg" alt="Cross Icon"
                                class="w-[30px] h-[30px] object-contain"> -->
                            <img src="../../../assets/images/modal-cross-icon.svg" alt="Cross Icon"
                                class="w-[30px] h-[30px] object-contain">
                        </button>
                        <div class="flex items-center gap-[5px] largeDesktop:gap-[10px]">
                            <div
                                class="flex items-center gap-2 rounded-full px-[12px] py-0.5 w-max bg-customYellow-100">
                                <img src="../../../assets/images/cart-check-white.png" alt="Cart Icon"
                                    class="mobile:w-[20px] mobile:h-[20px] largeDesktop:w-[30px] largeDesktop:h-[30px]">
                                <span
                                    class="mobile:leading-[1.5] mobile:text-[16px] tablet:text-[18px] largeDesktop:text-[24px] font-roboto font-medium text-white">{{
                                        modalCartCount
                                    }}</span>
                            </div>
                            <div class="leading-[1] text-white">
                                <h4 class="text-[20px] laptop:text-[24px] m-0 font-roboto font-medium">
                                    Cart</h4>
                                <p class="text-[12px] m-0 font-roboto font-normal">
                                    Check your plans before checkout</p>
                            </div>
                        </div>
                    </div>
                    <div class="relative px-[5px] laptop:px-2.5">
                        <span v-if="cartDetails.has_repair == true" @click="openCoverageModal()"
                            class="group w-[200px] tablet:w-[250px] h-[40px] mr-2 mt-[10px] tablet:mt-[20px] flex justify-center items-center ml-auto gap-1 font-poppins font-medium 
                            text-[12px] tablet:text-[14px] rounded-full cursor-pointer border-[1px] border-[#F5B134] bg-[#FDF9EE] !shadow-none laptop:hover:!shadow-[0px_5px_10px_0px_#f5b13466] CustomYellowBtn">
                            Review Coverage Amount 
                        </span>
                        <div v-if="false"
                            class="absolute right-[20px] top-0 group cursor-pointer flex items-center justify-center mobile:mx-auto tablet:!mx-0 gap-[10px] w-max tablet:w-auto rounded-full shadow-[0px_0px_10px_0px_#0000001A] p-[5px] pr-[10px] transition duration-300 bg-[#fff] hover:bg-[#14C38E]">
                            <div
                                class="min-w-[30px] min-h-[30px] flex items-center justify-center rounded-full shadow-[0px_0px_10px_0px_#0000001A] border-[2px] border-[#fff] bg-[#14C38E] text-[#fff]">
                                <i class="fa fa-plus"></i>
                            </div>
                            <p
                                class="m-0 font-roboto text-[16px] transition duration-300 text-[#000000]  group-hover:text-[#fff]">
                                Optional Coverages</p>
                        </div>
                        <div ref="scrollBox"
                            class="mobile:!max-h-[400px] tablet:!max-h-[550px] laptop:!max-h-[270px] largeDesktop:!max-h-[500px] overflow-y-auto customScrollbar flex flex-col gap-[10px] mt-2 largeDesktop:mt-4 laptop:pr-2 pt-3">
                            <bundleCartCard v-for="(bundle, index) in cartDetails.bundles" :key="index" :bundle="bundle"
                                :updateCart="updateBundleCart" :updateCard="updateCardCart" />
                            <cartCard v-for="(plan, index) in cartDetails.items" :key="index" :plan="plan"
                                :updateCart="updateCartCall" :updateCard="updateCardCart" />
                        </div>
                        <div class="py-2 largeDesktop:py-4 text-right border-b border-gray-200">
                            <h6 class="m-0 text-lg largeDesktop::text-xl font-roboto font-medium text-customBlue-100">
                                Total
                                Amount</h6>
                            <h2 class="m-0 text-[24px] largeDesktop:text-[40px] font-roboto font-bold  text-black">
                                ${{
                                    $helper.formatAmount(cartItemsTotal) }}/mo</h2>
                        </div>
                    </div>
                    <div class="flex items-center justify-center gap-[10px] mt-3 largeDesktop:mt-4">
                        <button @click="continueBtnClicked"
                            class="px-[15px] py-[8px] text-[14px] font-medium font-roboto rounded-[5px] CustomBlueBtn mb-1.5">
                            Continue to Checkout
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { Modal } from "bootstrap";
import cartCard from '../../../components/partnerCartCard/cartCard.vue';
import bundleCartCard from '../../../components/partnerCartCard/bundleCartCard.vue';

export default {
    data() {
        return {
            updateCardCart: null,
            isObserverAllow: false
        };
    },
    props: ["continueClicked", "updateCart", "openCoverageModal"],
    components: {
        cartCard,
        bundleCartCard
    },

    computed: {
        ...mapGetters([
            "cartDetails",
            "cartUpdated"
        ]),

        cartItemsTotal() {
            let total = 0
            if (this.cartDetails?.items?.length > 0) {
                total = this.cartDetails.items.reduce((sum, item) => sum + parseFloat(item.item_total_amount), 0);
            }

            if (this.cartDetails?.bundles?.length > 0) {
                this.cartDetails.bundles.forEach(item => {
                    const amount = Number(item.bundle_amount) || 0;
                    const qty = Number(item.bundle_quantity) || 0;
                    total += (amount * qty);
                });
            }
            return total
        },

        modalCartCount() {
            let totalQty = 0;

            if (this.cartDetails?.items?.length > 0) {
                this.cartDetails.items.forEach(item => {
                    const qty = Number(item.item_quantity) || 0;
                    totalQty += qty;
                });
            }

            if (this.cartDetails?.bundles?.length > 0) {
                this.cartDetails.bundles.forEach(item => {
                    const qty = Number(item.bundle_quantity) || 0;
                    totalQty += qty;
                });
            }
            return totalQty
        },

    },
    watch: {
        cartDetails: function (data) {
            if (this.cartDetails.bundles.length == 0 && this.cartDetails.items.length == 0) {
                this.closeModal()
                return
            }

            const modalEl = this.$refs.cartModal;
            if (this.modal || !this.isObserverAllow) return
            // Create bootstrap modal
            this.modal = new Modal(modalEl, { backdrop: 'static' });

            this.adjustPlanModalHeight();
            window.addEventListener('resize', this.adjustPlanModalHeight);
            window.addEventListener('orientationchange', this.adjustPlanModalHeight);
            // Fix scroll restore on close
            modalEl.addEventListener("hidden.bs.modal", () => {
                this.modal = null
                this.isObserverAllow = false
                window.addEventListener('resize', this.adjustPlanModalHeight);
                window.addEventListener('orientationchange', this.adjustPlanModalHeight);
            });

            modalEl.addEventListener("shown.bs.modal", () => {
                if (this.$refs.scrollBox) {
                    this.$refs.scrollBox.scrollTo({ top: 0, behavior: "smooth" });
                }
            });
            this.modal.show();
        },

        cartUpdated: function (data) {
            this.getCartDetails({})
        }


    },

    mounted() {

    },

    unmounted() {
        this.modal = null
        this.isObserverAllow = false
    },

    methods: {

        ...mapActions([
            "getCartDetails",
        ]),


        openModal() {
            this.isObserverAllow = true
            this.getCartDetails({})
        },

        closeModal() {
            
            if (this.modal) {
                this.$emit('close-cart-modal');
                this.modal.hide();
            }

        },

        continueBtnClicked() {
            this.closeModal()
            if (this.continueClicked) {
                this.continueClicked()
            }
        },

        adjustPlanModalHeight() {
            const modalContent = this.$refs.scrollBox;
            if (modalContent) {
                const vh = window.innerHeight;
                const vw = window.innerWidth;
                let maxHeight;
                if (vw < 300) {
                    maxHeight = vh * 0.6 - 40;
                } else if (vw < 768) {
                    maxHeight = vh * 0.6 - 50;
                } else if (vw < 991) {
                    maxHeight = vh * 0.6 - 50;
                } else if (vw < 1440) {
                    maxHeight = vh * 0.6 - 30;
                }
                else {
                    maxHeight = vh * 0.7 - 100;
                }
                modalContent.style.maxHeight = `${maxHeight}px`;
                modalContent.style.overflowY = 'auto';
            }
        },

        updateBundleCart(option, plan) {
            this.updateCart(option, plan, 'bundle', 'update')

        },
        updateCartCall(option, plan, type) {
            if (type == 'plan') {
                this.updateCart(option, plan, 'plan', '')
            }
            else {
                this.updateCart(option, plan, 'bundle', 'update')
            }
        },


    },
};
</script>
